<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading"/>
    <div v-else>
      <breadcrumb-component
          :moduleTitle="'Service management'"
          :mainTitle="'SSH Key Pair'"
          :subTitle="'SSH Key Pair List'"
      />
      <div class="row">
        <div class="col-md-12">
          <div class="card card_full_window vm_list_page ">
            <div class="card-body">
              <div class="common_content_wrap">
                <div class="common_content_left">
                  <ServiceLeftMenuComponent/>
                </div>
                <div class="common_content_right">
                  <div v-if="hasPagePermission('SSH Keypair')" class="vm_list_content">
                    <div class="d_flex_start pt_10 pb_10">
                      <div class="common_dropdown dropdown_no_radius mr_10" v-if="customer.selected_service_id == 1 || customer.selected_service_id == 2">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false">
                            <span v-if="selectedPlatform">{{ selectedPlatform.value }}</span>
                            <span v-else>All Platform</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button class="dropdown-item" type="button" @click.prevent="changePlatform(null)"><span>All Platform</span>
                            </button>
                            <li v-for="(serverPlatform, index) in serverPlatforms" :key="'server_platform_'+index"
                                @click.prevent="changePlatform(serverPlatform)">
                              <button class="dropdown-item" type="button"><span>{{ serverPlatform.value }}</span></button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="common_dropdown dropdown_no_radius">
                        <div class="btn-group dropdown-center dropdown-fill-text">
                          <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown"
                          aria-expanded="false">
                            <span v-if="selectedRegion">{{ selectedRegion.name }}</span>
                            <span v-else>All Region</span>
                          </button>
                          <ul class="dropdown-menu no_arrow">
                            <button class="dropdown-item" type="button" @click.prevent="changeRegion(null)"><span>All Region</span>
                            </button>
                            <li v-for="(serverRegion, index) in serverRegions" :key="'server_region_'+index"
                                @click.prevent="changeRegion(serverRegion)">
                              <button class="dropdown-item" type="button"><span>{{ serverRegion.name }}</span></button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="d_flex_start pt_10 pb_10">
                      <button
                        v-if="hasPermission('Create') && customer.selected_service_id && customer.selected_service_id != 1 && selectedService.id !== 4"
                        type="button"
                        class="btn btn-outline-primary btn-sm mr_15 width_250p"
                        @click="openModal()"
                      >
                        Create SSH Key Pair
                      </button>
                      <button
                        v-if="hasPermission('Delete')"
                        type="button"
                        class="btn btn-outline-danger btn-sm width_100p"
                        @click.prevent="deleteTheRecord()"
                        :disabled="!canDelete"
                      >
                        Delete
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm ml_15 width_100p"
                        @click.prevent="loadData()"
                      >
                        Refresh
                      </button>
                    </div>
                    <cloud-table-component
                        :columns="columns"
                        :rows="firewalls"
                        :sortable="sortable"
                        :pagination="pagination"
                        @sorting="sorting"
                        @pageChanged="pageChanged">

                        <template v-slot:kt_platform="{ row }">
                          <span v-if="row.kt_platform == 'g'" class="color_success">G</span>
                          <span v-if="row.kt_platform == 'd'" class="color_warning">D</span>
                        </template>

                        <template v-slot:keypair="{ row }">
                          <button type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p"
                                @click.prevent="downloadSshKey(row)">Download</button>
                        </template>

                      <template v-slot:id="{ row }">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                                 @focus="checkSingleSshKeypair(row, $event)" :checked="selectedItem?.id === row.id">
                          <label class="form-check-label" :for="'action_'+row.id"></label>
                        </div>
                      </template>

                    </cloud-table-component>
                  </div>
                  <div v-else>
                    <p>You do not have permission to view this content.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BaseModal
          v-if="isShowContactModal"
          title="Create SSH Key Pair"
          :closeModal="closeModal"
      >
        <template v-if="selectedService?.slug === 'vlan24-cloud'">
        <ProxmoxSshKeyPairForm
            :closeModal="closeModal"
            :loadData="loadData"
            :editId="editId"
            @setCreatedRecord="setCreatedRecord"
        />
        </template>
        <template v-else>

          <SshKeyPairForm
              :closeModal="closeModal"
              :loadData="loadData"
              :editId="editId"
              @setCreatedRecord="setCreatedRecord"
          />
        </template>
      </BaseModal>
      <BaseModal
          v-if="isShowSshDownloadModal"
          title="Download SSH Key"
          :closeModal="sshKeyDownloadModalClose"
      >
        <DownloadSshKeyPair
            :closeModal="sshKeyDownloadModalClose"
            :sshRecord="sshRecord"
        />
      </BaseModal>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
import ServiceLeftMenuComponent from "../ServiceLeftMenuComponent.vue";
import CloudTableComponent from '@/components/shared/CloudTableComponent.vue';
import BreadcrumbComponent from '@/components/shared/BreadcrumbComponent.vue';
import BaseModal from "@/components/BaseModal.vue";
import SshKeyPairForm from "./SshKeyPairForm.vue";
import {checkPermission} from "@/mixins/permissionsHelper";
import DownloadSshKeyPair from "@/views/services/sshKeypair/DownloadSshKey.vue";
import ProxmoxSshKeyPairForm from "@/views/services/sshKeypair/ProxmoxSshKeyPairForm.vue";

export default {
  name: 'SshKeyPairIndex',
  components: {
    ProxmoxSshKeyPairForm,
    DownloadSshKeyPair,
    LoaderMaskComponent,
    ServiceLeftMenuComponent,
    CloudTableComponent,
    BreadcrumbComponent,
    BaseModal,
    SshKeyPairForm,
  },
  data() {
    return {
      lyLoading: false,
      selectedPlatform: null,
      firewalls: [],
      serverRegions: [],
      selectedRegion: null,
      filter: {
        kt_platform: '',
        server_region_id: '',
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Name",
          field: "name",
          sortable: true,
        },
        {
          label: "Region",
          field: "region.name",
          sortable: false,
        },
        {
          label: "Kt platform",
          field: "kt_platform",
          sortable: true,
          slot: true,
        },
        {
          label: "Fingerprint",
          field: "fingerprint",
          sortable: true,
        },
        {
          label: "Created at",
          field: "created_at",
          sortable: true,
        },
        {
          label: "Keypair",
          field: "keypair",
          sortable: false,
          slot: true,
        }
      ],
      update: {
        kt_platform: '',
        server_region_id: '',
      },
      pagination: null,
      selectedItem: null,
      isShowContactModal: false,
      editId: null,
      isShowSshDownloadModal: false,
      sshRecord: null,
      selectedService: null,
    }
  },
  computed: {
    ...mapGetters({
      customer: 'auth/getUserInfo',
      permissions: 'serverPermissions/getServicePermission',
      services: 'auth/getCustomerServices',
    }),
    canDelete() {
      return !!(this.selectedItem);
    },
    serverPlatforms(){
      if(this.customer.g_platform && this.customer.d_platform){
        return [
          {label: 'g', value: 'G'},
          {label: 'd', value: 'D'},
        ];
      }else if(this.customer.g_platform){
        return [
          {label: 'g', value: 'G'},
        ];
      }else if(this.customer.d_platform){
        return [
          {label: 'd', value: 'D'},
        ];
      }else{
        return [
          {label: 'g', value: 'G'},
        ];
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
    customer: {
      handler(newVal, oldVal) {
        if (newVal?.selected_service_id !== oldVal?.selected_service_id) {
          // Perform actions when selected_service_id changes
          const newService = this.services.find((item) => item.id === parseInt(newVal?.selected_service_id));
          if (newService) {
            this.selectedService = newService
          } else {
            console.log('No matching service found');
          }
        }
        this.loadServerRegions()
        this.loadData();
      },
      deep: true, // Watch for changes in nested properties
      immediate: true, // Optional: Run the watcher immediately on component creation
    },
  },
  created() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadServerRegions()
    this.loadData();
  },
  mounted() {
    if(this.$route.query.kt_platform){
      let platform = this.serverPlatforms.filter(item => item.label === this.$route.query.kt_platform)
      if(platform && platform.length > 0){
        this.selectedPlatform = platform[0]
      }
    }
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        kt_platform: query.kt_platform,
        server_region_id: query.server_region_id,
      }

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {
        kt_platform: '',
        server_region_id: '',
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    changePlatform(platform) {
      if (platform) {
        this.selectedPlatform = platform
      } else {
        this.selectedPlatform = ''
      }

      this.queryParams.page = 1;
      this.filter.kt_platform = this.selectedPlatform ? this.selectedPlatform.label : '';
      this.changeRoute()
    },
    loadServerRegions() {
      this.axios.get('/server-regions')
      .then(({data}) => {
        this.serverRegions = data.data
        if(this.$route.query.server_region_id){
          let region = this.serverRegions.filter(item => item.id == this.$route.query.server_region_id)
          if(region && region.length > 0){
            this.selectedRegion = region[0]
          }
        }
      })
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/ssh-keypairs', {
        params: {...this.queryParams, ...this.filter}
      }).then((response) => {
        this.firewalls = response.data.data;
        this.pagination = response.data.meta;
      }).finally(() => {
        this.lyLoading = false;
      })
    },
    checkSingleSshKeypair(server, event) {
      event.target.blur();
      if (this.selectedItem?.id === server.id) {
        this.selectedItem = null;
      } else {
        this.selectedItem = server;
      }
    },
    changeRegion(region) {
      if (region) {
        this.selectedRegion = region
      } else {
        this.selectedRegion = ''
      }

      this.queryParams.page = 1;
      this.filter.server_region_id = this.selectedRegion ? this.selectedRegion.id : '';
      this.changeRoute()
    },
    deleteTheRecord(){
      if (this.selectedService.slug === 'vlan24-cloud'){
        this.deleteProxmoxRecord()
      } else {
        this.deleteRecord()
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/ssh-keypairs/' + this.selectedItem.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedItem = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    deleteProxmoxRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/proxmox/delete-ssh-key/' + this.selectedItem.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedItem = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.$swal({
                    text: response.data.message,
                    showCancelButton: false,
                    confirmButtonText: 'Close!',
                    confirmButtonColor: '#dd4b39',
                    reverseButtons: true
                  })
                }
              });
        }
      });
    },
    openModal(editId = null) {
      this.editId = editId
      this.isShowContactModal = true;
    },
    closeModal() {
      this.isShowContactModal = false;
    },
    hasPermission(action) {
      let sshIndex = this.permissions?.cloud_sub_service?.indexOf('SSH Keypair')
      let entity = this.permissions?.cloud_sub_service[sshIndex];

      return checkPermission(this.permissions, entity, action);
    },
    hasPagePermission(entityName) {
      return this.permissions?.cloud_sub_service?.includes(entityName) || this.permissions?.cloud_sub_service?.includes('All');
    },
    sshKeyDownloadModalOpen(){
      this.isShowSshDownloadModal = true
    },
    sshKeyDownloadModalClose(){
      this.isShowSshDownloadModal = false
    },
    setCreatedRecord(record){
      this.sshRecord = record
      this.sshKeyDownloadModalOpen()
    },
    downloadSshKey(sshRecord) {
      const filename = sshRecord?.name +'.pem'; // The name of the file to download

      // Create a Blob object from the string
      const blob = new Blob([sshRecord?.public_key], { type: 'text/plain' });

      // Create a download link and trigger it
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up the DOM
    },
  }
}
</script>